import React from 'react'
import { Link } from 'react-router-dom'
import { ListGroup } from 'react-bootstrap'
import { useTrackEvent } from '@ztechapps/webui.telemetry'
import { IconValueBlock, ShowIf } from '@ztechapps/webui.util'
import { Link as LinkNative } from '@ztechapps/webui.util'
import { routesDef } from '../../config/routes'
import { useUser } from '../../hooks/useUser'
import { MobileSideBarContainer } from '../MobileSideBarContainer'
import { useConversationWidgetContext } from '../ConversationWidget'
import styles from './MobileNavBar.module.scss'

type MobileNavBarProps = {
  show?: boolean
  onShow: () => void
}

export const MobileNavBar = ({ show = false, onShow }: MobileNavBarProps) => {
  const trackEvent = useTrackEvent()
  const { openConversationWidget } = useConversationWidgetContext()
  const { loggedIn } = useUser()

  const onRequestQuoteClick = () => {
    trackEvent('request_quote.click', { location: 'mobile_nav' })
    openConversationWidget()
  }

  const header = <h2>Browse Panelpunches</h2>

  return (
    <MobileSideBarContainer onShow={onShow} show={show} header={header}>
      <ListGroup variant="flush">
        <ListGroup.Item>
          <Link to={routesDef.HomePage.path} onClick={onShow}>
            <IconValueBlock icon="home" value={'Home'} />
          </Link>
        </ListGroup.Item>

        <ListGroup.Item>
          <Link to={routesDef.ProductListPage.altPath()} onClick={onShow}>
            <IconValueBlock icon="boxes-packing" value="All products" />
          </Link>
        </ListGroup.Item>
        <ListGroup.Item className={styles.requestQuoteHighlight}>
          <LinkNative onClick={onRequestQuoteClick}>
            <IconValueBlock icon="file-pen" value="Request a quote" />
          </LinkNative>
        </ListGroup.Item>
        <ShowIf condition={loggedIn}>
          <ListGroup.Item>
            <Link to={routesDef.AccountOrders.altPath()} onClick={onShow}>
              <IconValueBlock icon="file-invoice-dollar" value="My orders" />
            </Link>
          </ListGroup.Item>
        </ShowIf>
        <ListGroup.Item>
          <Link to={routesDef.UseAndCareListPage.altPath()} onClick={onShow}>
            <IconValueBlock icon="circle-info" value="Use and care" />
          </Link>
        </ListGroup.Item>
        <ShowIf condition={loggedIn}>
          <ListGroup.Item>
            <Link to={routesDef.AccountOverview.path} onClick={onShow}>
              <IconValueBlock icon="sliders" value="My account" />
            </Link>
          </ListGroup.Item>
        </ShowIf>

        <ShowIf condition={!loggedIn}>
          <ListGroup.Item>
            <Link to={routesDef.LoginPage.path} onClick={onShow}>
              <IconValueBlock icon="right-to-bracket" value="Sign In" />
            </Link>
          </ListGroup.Item>
        </ShowIf>
      </ListGroup>
    </MobileSideBarContainer>
  )
}
